<div class="stimulus-view">
  @for (stimulus of stimulus(); track stimulus.mediaId) {
    <div class="stimulus-view__media" [style.width]="width() + 'px'" [style.height]="height() + 'px'">
      <div class="stimulus-view__media-overlay"></div>
      <button
        mat-icon-button
        class="stimulus-view__media-view"
        [attr.data-testid]="'stimulus-preview-' + stimulus.mediaId + '-button'"
        title="View Stimulus"
        (click)="onPreview(stimulus)"
      >
        <fa-icon [icon]="faEye"></fa-icon>
      </button>
      @if (!readonly()) {
        <button
          mat-icon-button
          class="stimulus-view__media-delete"
          [attr.data-testid]="'stimulus-delete-' + stimulus.mediaId + '-button'"
          title="Delete Stimulus"
          (click)="delete.emit($index)"
        >
          <fa-icon [icon]="faClose"></fa-icon>
        </button>
      }
      @if (stimulus.type === fileType.VideoMp4) {
        <video [attr.data-testid]="'stimulus-video-' + stimulus.mediaId" controls [width]="width()" [height]="height()">
          <source [src]="stimulus.url" />
        </video>
      } @else if (stimulus.type === fileType.AudioMp3) {
        <audio [attr.data-testid]="'stimulus-audio-' + stimulus.mediaId" controls>
          <source [src]="stimulus.url" />
        </audio>
      } @else if (imageTypes.includes(stimulus.type)) {
        <img [alt]="stimulus.name" [src]="stimulus.url" [width]="width()" [height]="height()" />
      }
    </div>
  }
</div>
